export default function numericKeyboard() {
    function validateNumericFields(fieldId) {
        if ($('#' + fieldId).length) {
            let fieldVal = $('#' + fieldId).val();
            if (!$.isNumeric(fieldVal)) {
                $('#' + fieldId).val('');
            }
            if (fieldId == 'form_bank_accountNumber' || fieldId == 'customer_form_bankAccountNumber') {
                if (fieldVal.length > 8) {
                    $('#' + fieldId).val(fieldVal.substring(0, 8));
                }
            }
        }
    }
    $(document).ready(function() {
        if ($('#form_bank_accountNumber').length) {
            $('#form_bank_accountNumber').attr('maxlength', 8);
            $('#form_bank_accountNumber').attr('minlength', 8);
        }
        if ($('#customer_form_bankAccountNumber').length) {
            $('#customer_form_bankAccountNumber').attr('maxlength', 8);
            $('#customer_form_bankAccountNumber').attr('minlength', 8);
        }
        $(document).on('focus', '#form_phone_phoneNumber, #form_dateOfBirth_dateOfBirth_day, #form_dateOfBirth_dateOfBirth_month, #form_dateOfBirth_dateOfBirth_year, #billing_address_search_form_months_years, #billing_address_search_form_months_months, #billing_address_manual_form_months_years, #billing_address_manual_form_months_months, #form_bank_sortCode, #form_bank_accountNumber, #customer_form_bankAccountNumber, #customer_form_sortCode, #customer_form_mobileNumber', function() {
            $(this).attr('inputmode', 'numeric');
            $(this).attr('_originaltype', 'number');
        });
        $(document).bind('input propertychange', '#form_phone_phoneNumber', function() {
            validateNumericFields('form_phone_phoneNumber');
        });
        $(document).bind('input propertychange', '#form_dateOfBirth_dateOfBirth_day', function() {
            validateNumericFields('form_dateOfBirth_dateOfBirth_day');
        });
        $(document).bind('input propertychange', '#form_dateOfBirth_dateOfBirth_month', function() {
            validateNumericFields('form_dateOfBirth_dateOfBirth_month');
        });
        $(document).bind('input propertychange', '#form_dateOfBirth_dateOfBirth_year', function() {
            validateNumericFields('form_dateOfBirth_dateOfBirth_year');
        });
        $(document).bind('input propertychange', '#billing_address_search_form_months_years', function() {
            validateNumericFields('billing_address_search_form_months_years');
        });
        $(document).bind('input propertychange', '#billing_address_search_form_months_months', function() {
            validateNumericFields('billing_address_search_form_months_months');
        });
        $(document).bind('input propertychange', '#form_bank_sortCode', function() {
            validateNumericFields('form_bank_sortCode');
        });
        $(document).bind('input propertychange', '#form_bank_accountNumber', function() {
            validateNumericFields('form_bank_accountNumber');
        });
        $(document).bind('input propertychange', '#billing_address_manual_form_months_years', function() {
            validateNumericFields('billing_address_manual_form_months_years');
        });
        $(document).bind('input propertychange', '#billing_address_manual_form_months_months', function() {
            validateNumericFields('billing_address_manual_form_months_months');
        });
        $(document).bind('input propertychange', '#customer_form_mobileNumber', function() {
            validateNumericFields('customer_form_mobileNumber');
        });
        $(document).bind('input propertychange', '#customer_form_bankAccountNumber', function() {
            validateNumericFields('customer_form_bankAccountNumber');
        });
        $(document).bind('input propertychange', '#customer_form_sortCode', function() {
            validateNumericFields('customer_form_sortCode');
        });
    });
}
